module.exports = __webpack_public_path__ + "static/about-investition7-f7860e1d3fd20723cea36ed428d1ec7a.jpg";